$(document).ready(function () {  

  $('.hero-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: true
  });
  $('.product-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows:false,
    asNavFor:'.product-thumbs'
  });
  $('.product-thumbs').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    asNavFor:'.product-images',
    focusOnSelect: true,
    adaptiveHeight: false,
    variableWidth: true
  });

  $('.set-menu-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });



  if($(window).width() > 767){

    // tabbed content
    // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".tab_content").hide();
    $(".tab_content:first").show();

    /* if in tab mode */
    $("ul.tabs li").click(function () {

      $(".tab_content").hide();
      var activeTab = $(this).attr("rel");
      $("#" + activeTab).fadeIn();

      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

      $(".tab_drawer_heading").removeClass("d_active");
      $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

    });
    /* if in drawer mode */
    $(".tab_drawer_heading").click(function () {

      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel");
      $("#" + d_activeTab).fadeIn(100);

      if ($(this).hasClass('d_active')) {
        var d_activeTab = $(this).attr("rel");
        $("#" + d_activeTab).fadeOut(100);
      }

      $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");

      $("ul.tabs li").removeClass("active");
      $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
    });

    $('ul.tabs li').last().addClass("tab_last");
  }

  $('.rte img').addClass(
    function(){
      var floated = $(this).css('float');
      return floated ? 'img-' + floated : '';
    });

  $(".dataBg").css('background-image', function () {
    var bg = ('url(' + $(this).data("bg-src") + ')');
    return bg;
  });

  $('.header-initial .menu-bar button').click(function(){
    $('.site-header').addClass('visible');
    $('.header-initial').addClass('hidden');
  });
  var $nav = $('.header-initial'),
      $win = $(window),
      winH = $win.height();    // Get the window height.

  $win.on("scroll", function () {
    $nav.toggleClass("visible", $(this).scrollTop() > winH );
  }).on("resize", function(){ // If the user resizes the window
    winH = $(this).height(); // you'll need the new height value
  });
  $(window).scroll(function() {
    var sd = jQuery(window).scrollTop();
    if ( sd > 0 ) {
      $('.site-header').addClass('sticky');
    } else {
      $('.site-header').removeClass('sticky');
    }
  });
  function heightAdjust() {
    $(".mobile-menu").css({"padding-top": $(".site-header").height() });
  }

  heightAdjust();
  $( window ).resize(function() {
    heightAdjust();
  });

  $('.menu-opener').click(function(){
    $('.mobile-menu').toggleClass('open');
    $('body').toggleClass('body-hide');
  });

  $('.submenuOpen').click(function(){
    $(this).parent().toggleClass('active');
    $(this).parent().children('.mobile-submenu').slideToggle();
  });


  $(".cart-list tbody .desc .item-info button, .cart-list tbody .desc .item-info button").click(function(){
    $(".cart-list tbody .desc, .cart-list tbody .image").toggleClass("width-active");
  });



  /***************************/

  /*sortyby*/
  //   function sortBy() {
  //     var $sortBy = $('#SortBy');
  //     if (!$sortBy.length) {
  //       return;
  //     }
  //     $sortBy.on('change', function() {
  //       location.href = '?sort_by=' + $(this).val();
  //     });
  //   }
  //   sortBy();

  /*cook colelction page*/
  function tagBy() {
    var tagBy = $('#tag');
    if (!tagBy.length) {
      return;
    }
    tagBy.on('change', function() {
      location.href = $(this).val();
    });
  }
  tagBy();
  /*category*/
  function category() {
    var category = $('#category');
    if (!category.length) {
      return;
    }
    category.on('change', function() {
      location.href =  $(this).val();
    });
  }
  category();
  /*plus-minus-qty*/
  $('.plus').click(function () {
    $(this).prev().val(+$(this).prev().val() + 1);
  });
  $('.minus').click(function () {
    if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
  });
  /*delicious*/
  if(document.getElementById("delicious")){
    $("#delicious").click(function(e) {
      e.preventDefault();
      var id = $(this).attr('href');
      $('html,body').animate({scrollTop: $(id).offset().top - $('header.site-header').height()},'slow');
    });
  }
  jQuery(function() {
    function close_accordion_section() {
      $('.accordion-heading').removeClass('active');
      $('.accordion-content').slideUp(300).removeClass('open');
    }
    $('body').on('click','.accordion-heading',function(e){

      var currentAttrValue = $(this).data('id');
      if($(this).hasClass('active')) {
        close_accordion_section();
      }else {
        close_accordion_section();
        $(this).addClass('active');
        $('#'+currentAttrValue).slideDown(300).addClass('open'); 
      }
      e.preventDefault();
    });
  });

  /*cisit page*/
  $('.place-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows:true,
    adaptiveHeight: true
  });
  /*minicart*/
  $('.cart-icon').click(function(e){
    e.preventDefault();
    $('.mini-cart').addClass('active');
  });
  $('body').on('click','.mini-cart .mini-top .close-mini-cart',function(e){
    $('.mini-cart').removeClass('active');
  });
  /*addtocart*/
  function addToCartSuccess() {

    $.get( "/cart?view=mini", function( data ) {

      var data_v = $(data).find('.crt').html();
      console.log('Done');
      $('#crt').html(data_v);
      $('#crt').removeClass('loading');
    });


  }


  $('body').on('click','.addtocart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      success: function(line_item) {
        setTimeout(function(){ 
          if(typeof window.BOLD !== 'undefined' &&
             typeof window.BOLD.common !== 'undefined' &&
             typeof window.BOLD.common.cartDoctor !== 'undefined') {
            line_item = window.BOLD.common.cartDoctor.fixItem(line_item);
          }
        },100);

      },
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) { 
      console.log(data);
      addToCartSuccess();
      setTimeout(function(){ 
        $.getJSON('/cart.js', function(cart){
          console.log('enter');
          if(window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function'){
            cart = BOLD.common.cartDoctor.fix(cart);
          }
          if  (cart.item_count  == 0) {
            $('.cart_count').addClass('empy_cart').text(cart.item_count);
          }else{
            $('.cart_count').removeClass('empy_cart').text(cart.item_count);
          }

          document.dispatchEvent(new CustomEvent("zapiet:start"));
          if (window.Zapiet && window.ZapietCachedSettings) {   
            Zapiet.start(ZapietCachedSettings);
          }
        });
      },800);
      var text = btn.attr('data-text')
      btn.text(text).removeAttr('disabled');
      $('.mini-cart').addClass('active');
    });
  });
  /****/


  $('.select_box').click(function(){
    $('#category').slideToggle(500);
  });

  /*******************************************/
  if($(window).width() <= 1008){

    $('body').on('click', '.shop-side-bar', function(e) {
      $(".shop-section .left ul").toggleClass("mob-active");
      $(".mob-side-title").toggleClass("active");
      $(".body-overlay").toggleClass("active");
      $("body").toggleClass("body-hide");
    });

  }
  function product_width(){
    var cw = $('.product-image').width();
    $('.product-image').css({
      'height': cw + 'px'
    });
    $('.product-image img').css({
      'height': cw + 'px'
    });
  }
  function product_widthtwo(){
    var ca = $('.m-block img').width();
    $('.m-block img').css({
      'height': ca + 'px'
    });
  }
  function product_widththree(){
    var ct = $('.recipe-detail .col-6').width();
    $('.recipe-detail .col-6').css({
      'height': ct + 'px'
    });
  }
  $(window).resize(function () {
    product_width();
    product_widthtwo();
  });
  product_width();
  product_widthtwo();
  if(document.getElementById("collection")){
    var pInfScrLoading = false;
    var pInfScrDelay = 100;

    function pInfScrExecute() {
      var elm = document.getElementById('collection');
      var scrollHeight = elm.scrollHeight;
      var scrollTop = elm.scrollTop;
      var clientHeight = elm.clientHeight;
      var loadingmore;
      pInfScrNode = $('.more').last();
      pInfScrmore = $('.load-more a').last();
      pInfScrURL = $('.more a').last().attr("href");
      if(!pInfScrLoading && pInfScrNode.length > 0  && pInfScrNode.css('display') != 'none' ) {
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            loadingmore = pInfScrmore.clone().empty().append('<div class="show_more" >Loading...</div>');
            loadingmore.insertAfter(pInfScrmore);
            pInfScrNode.hide();
            pInfScrmore.hide();
          },
          success: function(data) {
            // remove loading feedback
            pInfScrNode.next().remove();
            pInfScrmore.next().remove();
            var filteredData = $(data).find(".collection-matrix").html();
            //filteredData.insertBefore( $("#product-list-foot") );
            $('.collection-matrix').append(filteredData);
            loadingmore.remove();
            pInfScrLoading = false;
            product_width();

          },
          dataType: "html"
        });

      }
    }
  }
  $('body').on('click', '.load-more',function(e){
    e.preventDefault();
    // $('.bottom_products').hide();
    if(document.getElementById("collection")){
      $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
      var elm = document.getElementById('collection');
      var scrollHeight = elm.scrollHeight;
      var scrollTop = elm.scrollTop;
      var clientHeight = elm.clientHeight;
      if(scrollHeight-scrollTop == clientHeight){
        pInfScrDelay = 100;
      }
    }
  });

  $('body').on('click','.link_title',function(e){
    e.preventDefault();
    var val = $(this).attr('data-id');
    $('.left').addClass('active');
    $('.menu-item.'+val).addClass('active');
  });
  $('body').on('click','.menu-back',function(e){
    var val = $(this).attr('data-id');
    $('.left').removeClass('active');
    $('.menu-item.'+val).removeClass('active');
  });
  $('body').on('click','.link_title_inner',function(e){
    e.preventDefault();
    var val = $(this).attr('data-id');
    $(this).closest('.chlid-menu').addClass('active');
    $(this).closest('.chlid-menu').find('.menu-item-chlid.'+val).addClass('active');
  });
  $('body').on('click','.menu-back-back',function(e){
    var val = $(this).attr('data-id');
    $('.chlid-menu').removeClass('active');
    $('.menu-item-chlid.'+val).removeClass('active');
  });

  $('body').on('click','.get_collection_item',function(e){
    e.preventDefault();
    var self =  $(this);
    $('.main-menu li a').removeClass('active');
    self.addClass('active');
    $('body').addClass('sidebar_active');

    var href1 = $(this).attr('href');
    $.get(href1+'?view=layout', function( data ) {
      var collection_sidbar = $(data).find('.right').html();
      var pageheader = $(data).find('.main-header-col').html();
      $('.right').html(collection_sidbar);
      $('.main-header-col').html(pageheader);
    }).done(function() {
      window.history.pushState("", "Title", href1);
      function sortBy() {
        var $sortBy = $('#SortBy');
        if (!$sortBy.length) {
          return;
        }
        $sortBy.on('change', function() {
          location.href = '?sort_by=' + $(this).val();
        });
      }
      sortBy();
      product_width();
      $('body').removeClass('sidebar_active');
      if($(window).width() <= 1008){
        if(self.closest('li').hasClass('end-nav')){
          $(".shop-section .left ul").toggleClass("mob-active");
          $(".mob-side-title").toggleClass("active");
          $(".body-overlay").toggleClass("active");
          $("body").toggleClass("body-hide");
        }
      }
    });
  });
  if($('.menu-item').hasClass('active')){
    $('.menu-item.active').closest('.menu-item').addClass('active');
    $('.menu-item.active').closest('.left').addClass('active');
  }
  if($('.menu-item-chlid').hasClass('active')){
    $('.menu-item-chlid.active').closest('.chlid-menu').addClass('active');
    $('.menu-item-chlid.active').closest('.menu-item').addClass('active');
    $('.menu-item-chlid.active').closest('.left').addClass('active');
  }
});

$(window).load(function () {
  var time = $('.landing-logo').attr('data-hide-time') * 1000;
  setTimeout(function(){ 
    $('.landing-logo').fadeOut();
    $('.landing-logo').next().delay(400).fadeIn('300');
    //console.log(time);
  }, time);
});

// $('.shop-header .browse-title').click(function(){
//   $('.shop-section .').toggleClass('open');
//   $('body').toggleClass('body-hide');
// });


document.addEventListener("DOMContentLoaded", function (e) {
  function t(e, t) {
    return (" " + e.className + " ").indexOf(" " + t + " ") > -1
  }

  window.onclick = function () {
    for (var e = document.getElementsByClassName("selectbox-options"), t = 0; t < e.length; t++) e[t].setAttribute("class", "selectbox-options selectbox-options--hidden")
      };
  for (var s = document.getElementsByClassName("justselect"), n = 0; n < s.length; n++) {
    s[n].required = !0, s[n].onchange = function () {
      var e = document.getElementsByClassName("selectbox__label"), t = this.value, s = this.dataset.sid,
          n = this.options;
      for (a = 0; a < e.length; a++) if (e[a].parentElement.dataset.pair === s) {
        for (b = 0; b < n.length; b++) if (n[b].value == t) {
          e[a].innerHTML = n[b].innerHTML;
          break
        }
        break
      }
    };
    var o = s[n].options, l = document.createElement("div");
    l.setAttribute("class", "selectbox"), l.setAttribute("data-pair", "select-" + (n + 1));
    var i = document.createElement("div");
    i.setAttribute("class", "selectbox__label"), l.appendChild(i);
    var c = document.createElement("div");
    c.setAttribute("class", "selectbox-options selectbox-options--hidden");
    for (var r = 0; r < o.length; r++) {
      var d = document.createElement("div");
      d.setAttribute("class", "selectbox__option"), d.setAttribute("data-value", o[r].value), !0 === o[r].selected && (d.setAttribute("class", d.className + " selectbox__option--selected"), i.innerHTML = o[r].text), o[r].disabled || (d.innerHTML = o[r].text, c.appendChild(d), l.appendChild(c))
    }
    !function (e, t) {
      e.parentNode.insertBefore(t, e.nextSibling)
    }(s[n], l), s[n].setAttribute("data-sid", "select-" + (n + 1)), s[n].style.display = "none"
  }
  for (var u = document.getElementsByClassName("justselect"), p = 0; p < u.length; p++) {
    var m = document.createElement("div");
    m.setAttribute("class", "justwrap");
    var h = document.getElementsByClassName("selectbox");
    u[p].parentElement.insertBefore(m, u[p]), h[p].parentElement.insertBefore(m, h[p]), m.appendChild(u[p]), m.appendChild(h[p])
  }
  for (var v = document.getElementsByClassName("selectbox__label"), x = 0; x < v.length; x++) v[x].onclick = function (e) {
    e.stopPropagation();
    var s = this, n = this.nextSibling, o = n.children;
    t(n, "selectbox-options--hidden") ? n.setAttribute("class", "selectbox-options") : n.setAttribute("class", "selectbox-options selectbox-options--hidden");
    for (var a = 0; a < o.length; a++) o[a].onclick = function () {
      for (var e = 0; e < o.length; e++) e != a && o[e].setAttribute("class", "selectbox__option");
      s.innerHTML = this.innerHTML, this.setAttribute("class", "selectbox__option selectbox__option--selected"), document.querySelectorAll('[data-sid="' + s.parentElement.dataset.pair + '"]')[0].value = this.dataset.value, n.setAttribute("class", "selectbox-options selectbox-options--hidden")
    }
      }
    });


$(document).ready(function(){    
  $('body').on('click','.selectbox__option',function(){
    var val = $('.selectbox__label').html();
    setTimeout(function(){ 
      console.log(val);
      if($('.form-fields .'+val).length){
        $('.cont_form').css('display','none');
        $('.contact-form .'+val).css('display','block');
      }
    }, 500);          	
  });
  /*pick-an-option*/
  //   if( typeof(productOptions ) != "undefined" ){
  //     for(i=0;i<productOptions.length;i++) {
  //       $('.single-option-selector:eq('+ i +')')
  //       .filter(function() {
  //         return $(this).find('option').length > 1
  //       })
  //       .prepend('<option value="">Pick a ' + productOptions[i][i] + '</option>')
  //       .val('')
  //       .trigger('change');
  //     }
  //   }
});


